/**
 * Single source of truth for the routes that prerender.mjs renders to static
 * HTML at build time. main.tsx hydrates these routes instead of re-rendering,
 * and entry-server.tsx re-exports the list for prerender.mjs to consume.
 *
 * When adding a page here, also:
 * 1. Add the route (static import, not lazy) in App.tsx AND entry-server.tsx.
 * 2. Add the path to StaticUrls in the backend SitemapService.cs.
 */
export const PRERENDERED_ROUTES: string[] = [
  '/',
  '/pricing',
  '/features/whatsapp',
  '/features/fees',
  '/features/accounting',
  '/features/reports',
  '/features/ecocash-payments',
  '/faq',
  '/features/zimsec-exams',
  '/secondary-schools',
  '/about',
  '/contact',
  '/terms',
  '/privacy-policy',
];
